<section class="container-fluid">
    <div class="col-12  d-flex justify-content-between">
    <h2 class="text-left text-white px-5 my-4">Formulario para crear un cliente.</h2>
    <div class="d-flex justify-content-center align-items-center">
      <button
          class="badge rounded-pill btn btn-outline-light mx-2"
          [routerLink]="['/pdg/client/list']"
          
        >
          <i class="fa-solid fa-right-from-bracket m-2 fs-6" aria-hidden="true"></i>
          <span class="m-2 fs-6">Volver al listado. </span>
          
        </button>
    </div>
  </div>
</section>
<section class="container-fluid shadow pt-3 pb-2 text-white backgroundTable mt-3 " style="min-height:750px !important;">
    <div class="container-fluid d-flex justify-content-between align-items-center">
        <div>
            <h5 class="ms-3">Ingrese los datos</h5>
        </div>
    </div>

    <!-- Datos -->
    <div class="componente-importantes text-start px-5 mt-3" style="min-height:750px ;">
        <form action="" method="post" (submit)="formSubmit()" [formGroup]="createClientForm">
        <section class="row  ">
            <div class="col-12  justify-content-lg-start">
                <div>
                    <label for="formControlInput" class="form-label mt-5"><b>Nombre cliente</b></label>
                    <input placeholder="Ingrese información" type="text" formControlName="name_client" class="form-control custom-outline-input date" >
                </div>
            </div>

                <div class="form-group">
                    <button type="button" style="float: left;" (click)="nuevoCampo()" class="mx-2 px-5 btn btn-outline-light mt-3 ">Agregar sucursal</button>
           
                </div>

                <form [formGroup]="paymentsform" class="mt-2">

                    <div formArrayName="items"
                        *ngFor="let item of paymentsform.get('items')['controls']; let i = index;">
                        <div class="row" [formGroupName]="i">
                            <div class="col-10">
                                <div class="form-group mt-1">
                                    <label for="formControlInput" class="form-label">Sucursal:</label>
                                    <input type="text" placeholder="Ingrese sucursal"
                                    class="form-control custom-outline-input date" formControlName="name">
                                </div>
                            </div>

                            <div class="col-2 d-flex align-items-end bd-highlight">
                                <button (click)="eliminarCampo(i)" style="float: right; float: button;" 
                                    class=" px-5 btn btn-outline-light">  <i class="fa-solid fa-trash-can"
                                        aria-hidden="true"></i></button>
                            </div>
                            
                        </div>


                    </div>

                </form>

                      <div class="col mt-4">
                            <label for="formControlInput" class="form-label ">Lider encargado</label>
                            <select required class="custom-outline-input form-select " formControlName="user_id" aria-label="Default select">
                                <option selected value=""> Seleccione...</option>
                                <option *ngFor="let item of listUser" [value]="item.id">{{item.username}}</option>
                            </select>
                    </div>
                
        </section>
    

        <footer class="row mt-5 pb-3">
            <div class="col-12 d-flex justify-content-end">
                <button class="mx-2 btn btn-outline-light"> <i class="fa fa-floppy-disk" aria-hidden="true"></i> Guardar
                    datos</button>
            </div>
        </footer>
    </form>
    </div>


</section>